import { gql, QueryHookOptions, useQuery } from "@apollo/client";
import { useGlobalDateRange } from "hooks/useGlobalDateRange";
import { toShortISOString } from "utils/date";
import { TRADE_ORDERS_DETAILS } from "./fragments";
import { PortfolioTradeOrdersQuery, TradeOrder} from "./types";

const PORTFOLIO_TRADE_ORDERS_QUERY = gql`
  ${TRADE_ORDERS_DETAILS}
  query GetPortfolioTradeOrders(
    $portfolioId: Long
    $startDate: String
    $endDate: String
  ) {
    portfolio(id: $portfolioId) {
      id
      tradeOrders(
        transactionStartDate: $startDate
        transactionEndDate: $endDate
      ) {
        ...TradeOrdersDetails
      }
      transactions(
        startDate: $startDate
        endDate: $endDate
        status: "NF"
      ) {
        ...TradeOrdersDetails
      }
    }
  }
`;

export const useGetPortfolioTradeOrders = (
  portfolioId: string | undefined,
  options?: QueryHookOptions
) => {
  const dateRangeProps = useGlobalDateRange();
  const { startDate, endDate } = dateRangeProps;

  const { loading, error, data } = useQuery<PortfolioTradeOrdersQuery>(
    PORTFOLIO_TRADE_ORDERS_QUERY,
    {
      variables: {
        startDate: toShortISOString(startDate),
        endDate: toShortISOString(endDate),
        portfolioId,
      },
      fetchPolicy: "cache-and-network",
      ...options,
    }
  );

  const tradeOrderModified: TradeOrder[] = []


  data?.portfolio.transactions.forEach((transaction) => {
    const copyTransaction = {...transaction};
    if (copyTransaction.tags) {
      if (copyTransaction.tags.includes("Deposit-waiting") && copyTransaction.tags.includes("Group-Nets") && !copyTransaction.tags.includes("Group-NetsAG")) {
        copyTransaction.orderStatus = "-5" 
      } else if (copyTransaction.tags.includes("Deposit-pending") && copyTransaction.tags.includes("Group-Nets") && !copyTransaction.tags.includes("Group-NetsAG")) {
        copyTransaction.orderStatus = "-6" 
      } else {
        copyTransaction.orderStatus = "-9" 
      }
      
    }
    
    tradeOrderModified.push(copyTransaction)

  })

  data?.portfolio.tradeOrders.forEach((transaction) => {

    tradeOrderModified.push(transaction)
    
  })


  return {
    loading,
    error,
    data: tradeOrderModified,
    ...dateRangeProps,
  };
};
